import { AccountProofI, UploadAccountProofParams } from '../domain';
import AccountRepositoryI from '../repository/AccountRepositoryI';
import AccountServiceI from './AccountServiceI';

export default class AccountService implements AccountServiceI {
  constructor(private repository: AccountRepositoryI) {}

  public async uploadProof(
    params: UploadAccountProofParams,
  ): Promise<AccountProofI> {
    return this.repository.uploadProof(params);
  }
}
